import { render, staticRenderFns } from "./goodsgroup.vue?vue&type=template&id=45396b07&scoped=true&"
import script from "./goodsgroup.vue?vue&type=script&lang=js&"
export * from "./goodsgroup.vue?vue&type=script&lang=js&"
import style0 from "./goodsgroup.vue?vue&type=style&index=0&id=45396b07&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45396b07",
  null
  
)

export default component.exports